function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", {
  id: "title"
}, "Close");

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.8,
  cy: 11.8,
  rx: 11.8,
  ry: 11.8,
  fill: "#428ee0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    className: "icon icon-close",
    viewBox: "0 0 24 24",
    "aria-labelledby": "title"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTMiIGhlaWdodD0iNTMiIGNsYXNzPSJpY29uIGljb24tY2xvc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0IiBhcmlhLWxhYmVsbGVkYnk9InRpdGxlIj4NCiAgICA8dGl0bGUgaWQ9InRpdGxlIj5DbG9zZTwvdGl0bGU+DQogICAgPGVsbGlwc2UgY3g9IjExLjgiIGN5PSIxMS44IiByeD0iMTEuOCIgcnk9IjExLjgiIGZpbGw9IiM0MjhlZTAiLz4NCiAgICA8cGF0aCBmaWxsPSJ3aGl0ZSIgZD0iTTE4Ljk4NCA2LjQyMmwtNS41NzggNS41NzggNS41NzggNS41NzgtMS40MDYgMS40MDYtNS41NzgtNS41NzgtNS41NzggNS41NzgtMS40MDYtMS40MDYgNS41NzgtNS41NzgtNS41NzgtNS41NzggMS40MDYtMS40MDYgNS41NzggNS41NzggNS41NzgtNS41Nzh6Ij48L3BhdGg+DQo8L3N2Zz4NCg0K";
export { SvgComponent as ReactComponent };